import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { createSlice } from "@reduxjs/toolkit";
var operations = [
    "list",
    "create",
    "transition",
    "delete",
    "items",
    "products",
    "brands",
    "addItem",
    "reduceItem",
    "cancelItem",
    "logs",
    "exportExcel"
];
var initialState = Object.fromEntries(operations.map(function(operation) {
    return [
        operation,
        {
            data: null,
            isFetching: false,
            isError: false,
            error: null,
            requestId: null
        }
    ];
}));
var stockCountSlice = createSlice({
    name: "stockCount",
    initialState: initialState,
    reducers: {
        resetState: function() {
            return initialState;
        }
    },
    extraReducers: function(builder) {
        builder.addMatcher(function(action) {
            var _action_type_split = _sliced_to_array(action.type.split("/"), 3), prefix = _action_type_split[0], operation = _action_type_split[1], status = _action_type_split[2];
            return prefix === "stockCount" && operations.includes(operation) && [
                "pending",
                "fulfilled",
                "rejected"
            ].includes(status);
        }, function(state, action) {
            var _action_type_split = _sliced_to_array(action.type.split("/"), 3), operation = _action_type_split[1], status = _action_type_split[2];
            var request = state[operation];
            if (status === "pending") {
                request.isFetching = true;
                request.isError = false;
                request.error = null;
                request.requestId = action.meta.requestId;
                return;
            }
            // ไม่ให้ response ของการค้นหาครั้งเก่าทับผลของ request ล่าสุด
            if (request.requestId !== action.meta.requestId) return;
            request.isFetching = false;
            if (status === "fulfilled") request.data = action.payload;
            else {
                var _action_error;
                request.isError = true;
                request.error = action.payload || ((_action_error = action.error) === null || _action_error === void 0 ? void 0 : _action_error.message);
            }
        });
    }
});
export var resetState = stockCountSlice.actions.resetState;
export default stockCountSlice.reducer;
